import React, { useEffect } from "react";
import LazyLoad from "react-lazyload";
import Header from "../Component/Header";
import { Link } from "react-router-dom";
const BoardingHouse = () => {
  useEffect(() => {
    document.title = "Boarding House -  The Air Force School Subroto Park";
  }, []);
  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/"> Home</Link>{" "}
          </li>
          <li> Facilities</li>
          <li>Boarding House</li>
        </ul>
      </div>
      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1> Boarding House </h1>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <h6>Rules and Regulations</h6>
              <p>
                Frequent transfers of Air Force Personnel owing to the
                exigencies of service often disrupt the education of their
                children. In order to overcome this problem, Boys' Hostel
                (classes VI to XII) was constructed in 1970. This facility is
                available only for the bonafide students of TAFS. The strength
                of the hostellers is 72.
              </p>
            </div>
            <div className="col-lg-3">
              <LazyLoad>
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/Boarding House.png"
                >
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/Boarding House.png"
                    className="schoollib img-fluid"
                    alt="TAFS"
                  />
                </a>
              </LazyLoad>
            </div>
            <div className="col-lg-3">
              <LazyLoad>
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/Boarding House1.jpg"
                >
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/Boarding House1.jpg"
                    className="schoollib img-fluid"
                    alt="TAFS"
                  />
                </a>
              </LazyLoad>
            </div>
            <div className="col-lg-3">
              <LazyLoad>
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/Boarding House2.jpg"
                >
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/Boarding House2.jpg"
                    className="schoollib img-fluid"
                    alt="TAFS"
                  />
                </a>
              </LazyLoad>
            </div>
            <div className="col-lg-3">
              <LazyLoad>
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/Boarding House3.jpg"
                >
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/Boarding House3.jpg"
                    className="schoollib img-fluid"
                    alt="TAFS"
                  />
                </a>
              </LazyLoad>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <ul className="list">
                <li>
                  {" "}
                  Boarders are provided with a bed, cupboard, a study unit and a
                  chair. Each boarder must maintain utmost cleanliness and make
                  sure that the floor under his bed and cupboard is clean. Waste
                  paper and refuse must be thrown in the dustbins provided in
                  the rooms.{" "}
                </li>

                <li>
                  {" "}
                  CUPBOARDS: Cupboards must be arranged neatly. Surprise checks
                  will be made by Hostel Wardens. Any extra items, other than
                  those specified in the hostel kit will be confiscated. Shoes
                  will be arranged neatly in the shoe rack. The number of shoes
                  is limited to five pairs.{" "}
                </li>

                <li>
                  {" "}
                  STUDY UNITS: Book shelves are to be used for books and
                  stationery only and not for toiletries. Books must be neatly
                  arranged and each boarder will be responsible for the cleaning
                  of his book shelf.{" "}
                </li>

                <li>
                  {" "}
                  EATS: Keeping eatables in the dorms is unhygienic and is
                  strictly prohibited. Please note that the computer games,
                  mobile, calculators, electronic items walkman's etc are NOT
                  PERMITTED.{" "}
                </li>

                <li>
                  {" "}
                  If any child wishes to play badminton or Table tennis, it
                  would be preferable if they have their own badminton rackets
                  /table tennis bats. This is not compulsory as we do provide
                  them from the school stock, but these have to be shared by
                  all. 6. All hostellers are expected to follow the rules of
                  conduct applicable to the students of the school in areas of
                  responsible conduct, proper uniform, classroom attendance and
                  appearing in examinations.{" "}
                </li>

                <li>
                  {" "}
                  Any absence from the classroom/non appearance in weekly test
                  requires sanction of the Hostel Warden and immediate
                  intimation of the same to the subject teacher/class
                  teacher.{" "}
                </li>

                <li>
                  {" "}
                  All hostellers are encouraged to make the best use of
                  excellent infrastructure provided in the hostel and also
                  protect it from damage. Careless breakage or damage is likely
                  to lead penalty, the nature of which shall be decided by the
                  warden.{" "}
                </li>

                <li>
                  {" "}
                  All details related to medical history, if applicable, must be
                  submitted to Warden to enable timely and appropriate medical
                  care 10. Pens, copies soaps, detergents and other items will
                  be provided by the parents / local guardians to their wards.
                  The boarders will not be allowed to go out of the hostel in
                  any case.{" "}
                </li>
              </ul>
              <h6>General rules for the Boarders</h6>
              <ul className="list">
                <li>
                  To engender and enhance discipline among our boarders we
                  request you to adhere to the following hostel rules:{" "}
                </li>{" "}
                <li>
                  Hostel students will follow the daily routine of the hostel
                  and school, unless exempted on medical grounds on
                  recommendations of the Hostel Warden/Medical officer.{" "}
                </li>{" "}
                <li>
                  {" "}
                  They are not allowed to keep or take medicines or tonic
                  without the knowledge of the Hostel Warden/Medical officer.
                  Any medicines, must be handed over to the Warden.{" "}
                </li>{" "}
                <li>
                  {" "}
                  Transistors, record players and tape recorders should not be
                  used in the rooms.{" "}
                </li>{" "}
                <li>
                  {" "}
                  They are not allowed to stay in the rooms during school hours,
                  games, activity and prep hours.{" "}
                </li>{" "}
                <li>
                  {" "}
                  They are not allowed to entertain any day scholar in their
                  rooms.{" "}
                </li>{" "}
                <li>
                  {" "}
                  Electric kettles, heaters, irons or any other electrical
                  appliances should not be used in the rooms.{" "}
                </li>{" "}
                <li>
                  {" "}
                  All notices will be put up on the hostel notice board.
                  Announcements, if any, will be made during dinner time/lunch
                  time.{" "}
                </li>{" "}
                <li>
                  {" "}
                  Please do not send any valuable articles/cash through your
                  ward(s) without the knowledge of House Warden/Principal.
                  Particularly those which are not enlisted in the given list of
                  items as given to you at the time of admission.{" "}
                </li>{" "}
                <li>
                  {" "}
                  Remedial classes will be taken for weak students from Monday
                  to Friday.{" "}
                </li>{" "}
                <li>
                  {" "}
                  Any hostel student falling sick will report to the clinic
                  through the Hostel Warden immediately.{" "}
                </li>{" "}
                <li>
                  {" "}
                  Expensive parties to celebrate birthdays are not allowed. The
                  school will arrange for a cake and sweets for a small party
                  within a reasonable amount. The House Warden will undertake
                  the arrangements for this. However amount to be spent for the
                  said party will be billed to the parents.{" "}
                </li>{" "}
                <li>
                  {" "}
                  The student should not carry any kind of tuck from home.
                  (Extra eatables, pickles, chutneys and digestive tablets are
                  not permissible.){" "}
                </li>{" "}
                <li>
                  {" "}
                  The child has an option of Co-Curricular activities,
                  Equestrian training, Aerobics, and Yoga to acquire his domain
                  individuality intuitive endowment.{" "}
                </li>{" "}
                <li>
                  {" "}
                  Parents are required to get the Student's Hostel Number
                  stitched on each clothing item (s) the student has.{" "}
                </li>{" "}
                <li>
                  {" "}
                  Student can avail the facility of Tuck shop, Tailor, Barber,
                  Cobbler in the boarding house on writing a slip with the
                  signature of the Warden{" "}
                </li>{" "}
                <li>
                  {" "}
                  Parents/Local guardians are requested to intimate to the
                  school in case of any change of address / phone numbers.{" "}
                </li>{" "}
                <li>
                  {" "}
                  Any misconduct and indiscipline will invite penalty.{" "}
                </li>{" "}
              </ul>

              <h6>Rules for Exit / Outing</h6>
              <ul className="list">
                {" "}
                <li>
                  {" "}
                  Parents are not allowed to meet their ward(s) in school/hostel
                  without the prior consent of the Principal.{" "}
                </li>{" "}
                <li>
                  {" "}
                  Children will be allowed to go for the outing only on the last
                  Saturday of the month. Parents are requested to pick their
                  child on the last Friday after 2.00 p.m. for the outing. The
                  students who do not fair in the regular cycle tests will not
                  be allowed to avail the outing. Please note that the hostel
                  children should report back to the hostel by 5.00 p.m. on
                  Sunday positively.{" "}
                </li>{" "}
                <li>
                  {" "}
                  Gate pass for Day/night out or to meet your ward (s) can be
                  issued by the concerned warden.{" "}
                </li>{" "}
                <li>
                  {" "}
                  In case of emergency exit, after discussion with the
                  Principal, the warden may issue the gate pass.{" "}
                </li>{" "}
                <li>
                  {" "}
                  When students are unable to return on time after
                  weekends/holidays, leave letter should be sent to the Warden
                  by local guardians within 24 hours. Such leave will be only
                  granted for medical reasons and a medical certificate should
                  be submitted along with the leave application.{" "}
                </li>{" "}
                <li>
                  {" "}
                  If any student overstays his outing and returns late to the
                  hostel, will not be accepted by the hostel warden until for
                  genuine medical reasons.{" "}
                </li>{" "}
              </ul>
              <h6>Visiting and Visiting Hours</h6>
              <ul className="list">
                <li>
                  {" "}
                  An identity card will be issued to each hostel student and his
                  local guardians. No local guardians will be permitted to visit
                  their wards without an identity card.{" "}
                </li>

                <li>
                  {" "}
                  Parents and local guardians may visit their wards only on last
                  Sunday in a month (provided the child has not had an outing
                  and will not take an outing for the month) between 3.00 p.m.
                  to 5 p.m. with prior information to the warden.{" "}
                </li>

                <li>
                  {" "}
                  Visitor will meet their ward in the visitor's room. Parents
                  are not allowed to meet their ward anywhere else.{" "}
                </li>

                <li>
                  {" "}
                  In case of any emergency, visits can be arranged with the
                  principal's permission.{" "}
                </li>

                <li>
                  {" "}
                  One security guard will be on duty, at the main gate to
                  prohibit boarders from leaving the school premises without
                  permission. He will keep record in a register, of visitors
                  entering the school premises to see hostel student.{" "}
                </li>
              </ul>
              <h6>Hostel Schedule</h6>
              <p>Schedule for the Boarders (Mon-Sat)</p>
              <div className="table-responsive maintable">
                <table className="table">
                  <tbody>
                    {" "}
                    <tr>
                      {" "}
                      <td> 6.00 a.m. </td> <td> Wake up call </td>{" "}
                    </tr>{" "}
                    <tr>
                      {" "}
                      <td> 6.15 a.m. to 6.45 a.m. </td>{" "}
                      <td> Warming up Exercises </td>{" "}
                    </tr>{" "}
                    <tr>
                      {" "}
                      <td> 6.45 a.m. to 7.15 a.m. </td>{" "}
                      <td> To get ready for school </td>{" "}
                    </tr>{" "}
                    <tr>
                      {" "}
                      <td> 7.15 a.m. to 7.45 a.m. </td>{" "}
                      <td> Breakfast </td>{" "}
                    </tr>{" "}
                    <tr>
                      {" "}
                      <td> 7.45 a.m. </td> <td> Roll call </td>{" "}
                    </tr>{" "}
                    <tr>
                      {" "}
                      <td> 8.00 a.m. to 2.00 p.m. </td>{" "}
                      <td> School Hours </td>{" "}
                    </tr>{" "}
                    <tr>
                      {" "}
                      <td> 2.00 p.m. </td> <td> Roll call </td>{" "}
                    </tr>{" "}
                    <tr>
                      {" "}
                      <td> 2.05 p.m. to 2.15 p.m. </td>{" "}
                      <td> Change into Hostel Uniform </td>{" "}
                    </tr>{" "}
                    <tr>
                      {" "}
                      <td> 2.15 p.m. to 2.45 p.m. </td> <td> Lunch </td>{" "}
                    </tr>{" "}
                    <tr>
                      {" "}
                      <td> 2.45 p.m. to 4.00 p.m. </td> <td> Rest </td>{" "}
                    </tr>{" "}
                    <tr>
                      {" "}
                      <td> 4.00 p.m. to 5.00 p.m. </td>{" "}
                      <td> Evening Games </td>{" "}
                    </tr>{" "}
                    <tr>
                      {" "}
                      <td> 5.00 p.m. to 6.00 p.m. </td>{" "}
                      <td> Bath &amp; Snacks </td>{" "}
                    </tr>{" "}
                    <tr>
                      {" "}
                      <td> 6.00 a.m. to 8.00 p.m. </td>{" "}
                      <td> Prep Hours </td>{" "}
                    </tr>{" "}
                    <tr>
                      {" "}
                      <td> 8.00 p.m. to 9.00 p.m. </td> <td> Dinner </td>{" "}
                    </tr>{" "}
                    <tr>
                      {" "}
                      <td> 9.00 p.m. </td> <td> Roll call </td>{" "}
                    </tr>{" "}
                    <tr>
                      {" "}
                      <td> 9.00 p.m. to 9.30 p.m. </td> <td> News </td>{" "}
                    </tr>{" "}
                    <tr>
                      {" "}
                      <td> 9.30 p.m. to 10.30 p.m. </td>{" "}
                      <td> Self-study (VII-X) </td>{" "}
                    </tr>{" "}
                    <tr>
                      {" "}
                      <td> 10.30 p.m. </td> <td> Lights off </td>{" "}
                    </tr>{" "}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BoardingHouse;
